import { $host, handleError, handleResponse } from "./index";

export const courses = async () => {
    try {
        const res = await $host.get(`/api/public/courses`, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
};

export const coursesByID = async (course_id) => {
    if (!course_id) throw new Error('Не указан course_id')
    try {
        const res = await $host.get(`/api/public/courses/${course_id}`, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
}

export const subjects = async () => {
    try {
        const res = await $host.get(`/api/public/subjects`, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
};

export const subjectsByID = async (subject_id) => {
    if (!subject_id) throw new Error('Не указан subject_id');
    try {
        const res = await $host.get(`/api/public/subjects/${subject_id}`, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
};

export const subjectsByIDandCourse = async (subject_id) => {
    try {
        const res = await $host.get(`/api/public/subjects/${subject_id}/courses`, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
};

export const studentCoursesByUserID = async (user_id) => {
    if (!user_id) throw new Error('Не указан user_id')
    try {
        const res = await $host.get(`/api/students/courses/${user_id}`, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error)
    }
};

export const courseParagraph = async (course_id) => {
    if (!course_id) throw new Error('Не указан course_id')
    try {
        const res = await $host.get(`/api/students/courses/paragraphs/${course_id}`, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
};

export const courseParagraphByID = async (paragraph_id) => {
    if (!paragraph_id) throw new Error('Не указан paragraph_id')
    try {
        const res = await $host.get(`/api/students/paragraphs/${paragraph_id}`, { withCredentials: true });
        return handleResponse(res);
    } catch (error) {
        handleError(error);
    }
};










